module.exports = __webpack_public_path__ + "img/43.2aed01c9.png";